import { useLanguage } from "@/contexts/LanguageContext";

export function WhoItsForSection() {
  const { t } = useLanguage();

  const goodFor = [
    t("landing.whoItsFor.good1"),
    t("landing.whoItsFor.good2"),
    t("landing.whoItsFor.good3"),
    t("landing.whoItsFor.good4"),
  ];

  const notFor = [t("landing.whoItsFor.not1")];

  return (
    <section className="bg-background py-10 sm:py-12">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-lg sm:text-xl font-bold text-foreground mb-6 tracking-tight">
          {t("landing.whoItsFor.headline")}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {/* Good for */}
          <div className="border-accent-left pl-4">
            <h3 className="text-xs font-bold text-foreground uppercase tracking-widest mb-3">
              {t("landing.whoItsFor.goodForLabel")}
            </h3>
            <ul className="space-y-2">
              {goodFor.map((item, index) => (
                <li key={index} className="text-sm text-muted-foreground">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Not for */}
          <div className="pl-4 border-l-3 border-border">
            <h3 className="text-xs font-bold text-foreground uppercase tracking-widest mb-3">
              {t("landing.whoItsFor.notForLabel")}
            </h3>
            <ul className="space-y-2">
              {notFor.map((item, index) => (
                <li key={index} className="text-sm text-muted-foreground">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
